import React, { useState, useEffect } from 'react';
import Form from '../form/Form';
import ApiService from '../../services/ApiService';

const EquipmentSettings = () => {
  const [ready, setReady] = useState(false);
  const [layout, setLayout] = useState([]);

  const handleSubmit = payload => {
    return ApiService.put('/crm/settings', payload);
  };

  const fetchSettings = () => {
    return ApiService.get('/crm/settings/layout').then(response => {
      setLayout(response.data.layout);
      setReady(true);
    });
  };

  useEffect(() => {
    fetchSettings();
  }, []);

  if (!ready) {
    return null;
  }

  return <Form className="eqs-settings" layout={layout} submit={handleSubmit} exportFormat="object" />;
};

export default EquipmentSettings;
